module.exports = __webpack_public_path__ + "static/media/policy-new-doc.191b5567.pdf";